import type { IBaseCustomer } from "../../BaseCustomerFactory";
import type { IRef } from "@Front/Api/BaseApiService";
import { extractFileNameFromContentDisposition } from "@Front/Utils/downloadHelpers";
import { downloadMultipleFiles } from "@Front/Api/LeCoffreApi/helpers/fileDownloadHelpers";
import { getFilesNotaryInstance, type FilesNotaryDownloadResult } from "../FilesFactory";

export function createDownloadMethod() {
	return async (filesNotaryUid: string, documentsNotaryUid: string, withCertificate?: boolean): Promise<Blob> => {
		const result = await getFilesNotaryInstance().downloadWithFileName(
			filesNotaryUid,
			documentsNotaryUid,
			withCertificate,
			"document.pdf",
		);
		return result.blob;
	};
}

export function createDownloadWithFileNameMethod(baseCustomer: IBaseCustomer, baseUrl: string) {
	return async (
		filesNotaryUid: string,
		documentsNotaryUid: string,
		withCertificate?: boolean,
		fallbackFileName = "document.pdf",
	): Promise<FilesNotaryDownloadResult> => {
		const url = new URL(baseUrl.concat(`/${filesNotaryUid}/documents-notary/${documentsNotaryUid}/download`));
		if (withCertificate) {
			url.searchParams.set("with_certificate", "true");
		}
		try {
			const ref: IRef = {};
			const blob = await baseCustomer.getRequest<Blob>(url, { ref });
			const contentDisposition = ref.response?.headers.get("Content-Disposition") ?? null;
			const contentType = ref.response?.headers.get("Content-Type") ?? null;
			const fileName = extractFileNameFromContentDisposition(contentDisposition, fallbackFileName ?? "document.pdf");
			return { blob, fileName, contentType, contentDisposition };
		} catch (err) {
			baseCustomer.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createDownloadMultipleMethod(baseCustomer: IBaseCustomer, baseUrl: string) {
	return async (fileUids: string[], includeAnchors = true, folderNumber?: string, folderName?: string): Promise<Blob> => {
		return downloadMultipleFiles(baseCustomer, baseUrl, { fileUids, includeAnchors, folderNumber, folderName });
	};
}
